import { render, staticRenderFns } from "./OrdersTableName.vue?vue&type=template&id=fc976db0&"
import script from "./OrdersTableName.vue?vue&type=script&lang=js&"
export * from "./OrdersTableName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports